<template>
  <div>
    <list-accessories
      v-show="!isShowDetial"
      @addNews="addNews"
      @editItem="editItem"
    ></list-accessories>
    <accessories-detail
      v-if="isShowDetial"
      :isAddNew="isAddNew"
      :itemSelected="itemSelected"
      @close="close"
    ></accessories-detail>
  </div>
</template>
<script>
export default {
  components: {
    ListAccessories: () => import("./ListAccessories"),
    AccessoriesDetail: () => import("./AccessoriesDetail")
  },
  data() {
    return {
      isShowDetial: false,
      isAddNew: false,
      itemSelected: {}
    };
  },
  methods: {
    addNews() {
      this.isAddNew = true;
      this.isShowDetial = true;
    },
    editItem(item) {
      this.isShowDetial = true;
      this.isAddNew = false;
      this.itemSelected = item
    },
    close() {
      this.isAddNew = false;
      this.isShowDetial = false;
    }
  }
};
</script>